import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as _ from 'underscore';
import * as M from 'mapbox-gl';
import * as jQuery from 'jquery';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, MAP_CONSTANTS, PRODUCT_NAMES } from '../../../analytics/constants/analytics.constants';
import { MapComponentService, MapLegendItem } from '../map/map.component.service';
import { MapComponent } from '../map/map.component';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';
@Component({
	selector: 'app-marketron-map',
	templateUrl: './marketron-map.component.html',
	styleUrls: ['./marketron-map.component.css'],
	providers: [MapComponentService]
})
export class MarketronMapComponent extends MapComponent implements OnInit, AfterViewInit, OnDestroy {
	/**
	 * Input's
	 */
	@Input() key: string;
	@Input() path: string;
	@Input() timeserieskey: string;
	@Input() markericon: string;
	@Input() uniqueoverwriteid: string;
	@Input() geofencegeovideocallattibutekey: any;

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 2
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 3
		},
		{
			productName: 'CTV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 4
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 5
		}
	];

	/**
	 *
	 * @type {{productName: string; productKey: string; showInLegend: boolean; show: boolean; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected GF_PRODUCTS = [
		{
			productName: 'GeoFence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'GeoVideo',
			productKey: 'geovideo',
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasGeoVideo']
		}
	];

	protected mapStyle = 'mapbox://styles/freq-e-deek/cjbpmvz7i0jks2so36im91k7n';
	protected satelliteMapStyle = 'mapbox://styles/mapbox/satellite-streets-v9';

	public products: any;
	public geofenceLegend: any;
	public showLiftDetails = true;

	protected imageAdded = false;
	protected isSatelliteMapEnabled = false;

	protected geoFenceMarkersDrawn = false;
	protected geoVideoMarkersDrawn = false;
	protected geoFenceRecencyLayersDrawn = false;
	protected geoVideoRecencyLayersDrawn = false;
	protected geoFenceMarkers = [];
	protected geoVideoMarkers = [];

	protected onlyGeoFenceProductsSelected = false;
	protected mapFillColor = 'rgba(117,134,166,1)';
	protected mapFillOutlineColor = 'rgba(53,80,142, 0.8)';
	public toggleMapProductSubscription;
	public updateMapProductSubscription;

	protected selectedGeofenceProducts;
	protected geoFenceCircleColor = '#304150';
	protected geoRecencyCircleColor = '#D1D4D5';
	protected geoRecencyCircleStrokeColor = '#304150';
	protected geoFenceStrokeColor = '#FFFFFF';
	protected displayGeoRecencyStrokeColor = '#304150';

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
		this.toggleMapProductSubscription = EmitterService.get(EVENT_EMITTERS.TOGGLE_PRODUCT_MAP_LEGEND).subscribe(
			(response: any) => {
				this.processProductToggleResponse(response);
			}
		);
		this.updateMapProductSubscription = EmitterService.get(EVENT_EMITTERS.UPDATE_PRODUCT_MAP_LEGEND).subscribe(
			(response: any) => {
				const selectedProducts = response.selected;
				this.updateLegendItems(selectedProducts);
			}
		);
	}

	ngOnInit() {
		super.ngOnInit();
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 28;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 4;
		this.defaultMapZoom = 3.6;
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.toggleMapProductSubscription) {
			this.toggleMapProductSubscription.unsubscribe();
		}
		if (this.updateMapProductSubscription) {
			this.updateMapProductSubscription.unsubscribe();
		}
	}

	initializeMap() {
		this.map = new M.Map({
			container: 'map', // container id
			style: this.mapStyle, // stylesheet location
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom // starting zoom
		});
		this.map.scrollZoom.disable();
		this.map.on('load', () => {
			this.map.on('mousemove', 'geofence-markers', (e) => {
				this.showGeofenceCenterDetails(e.features[0].properties);
			});

			this.map.on('mouseleave', 'geofence-markers', () => {
				this.hideGeofenceCenterDetails();
			});

			this.map.on('zoomend', () => {
				if (this.map.getZoom() >= 13) {
					if (!this.isSatelliteMapEnabled) {
						this.isSatelliteMapEnabled = !this.isSatelliteMapEnabled;
						this.map.setStyle(this.satelliteMapStyle);
					}
				} else if (this.isSatelliteMapEnabled) {
					this.isSatelliteMapEnabled = !this.isSatelliteMapEnabled;
					if (
						(this.displayGeoFenceData.features.length > 0 || this.prerollGeoFenceData.features.length > 0) &&
						this.mapObj.combinations.length === 0
					) {
						this.selectedCombination = {};
						this.refreshMap();
						this.drawCenter();
					}
					this.map.setStyle(this.mapStyle);
				}
				this.zoomChanged();
			});

			this.map.on('style.load', (event) => {
				if (!this.isSatelliteMapEnabled) {
					this.processResponseData();
				} else {
					this.drawAllGeoFencePoints();
				}
				this.drawGeoRecencyLayers();
			});
		});
	}

	protected drawMap() {
		this.removeAllGeoRecencyLayers();
		this.removeAllGeoFenceMarkers();
		this.geoFenceMarkers = [];
		this.geoVideoMarkers = [];
		if (!_.isEmpty(this.displayGeoFenceData) && !_.isEmpty(this.prerollGeoFenceData)) {
			this.drawGeoFenceLayers();
		} else {
			if (this.imageAdded) {
				this.map.removeImage('geofence');
			}
			this.imageAdded = false;
			this.removeMapLayer('geofence-markers');
			this.removeMapSource('geofence-markers');
		}
		this.drawGeoRecencyLayers();
		if (this.selectedCombination) {
			this.processResponseData();
		} else {
			this.refreshMap();
		}
		this.showLoad = false;
	}

	protected drawCenter() {
		if (this.selectedCombination && this.selectedCombination.center) {
			this.map.easeTo({
				padding: { top: 100, bottom: 300, left: 400, right: 20 },
				center: this.selectedCombination.center,
				zoom: this.selectedCombination.zoomRange,
				duration: 0
			});
		} else if (this.onlyGeoFenceProductsSelected) {
			const mapBounds = this.boundsForAvailableGeoFenceProducts;
			let zoomRange = this.get_bounds_zoom(mapBounds);
			// setting zoomRange to 12 to avoid the map to take original zoom level that is more ex: 21
			// this occurs when a particular campaign is selected with the default zoom range
			// Note: If zoom level > 12 then Satellite view will be enabled
			zoomRange = zoomRange > 12 ? 12 : zoomRange;
			if (this.selectedGeofenceProducts.length === this.GF_PRODUCTS.length) {
				this.drawGeoProductsMapBounds(mapBounds, zoomRange);
			} else if (
				this.selectedGeofenceProducts.length === 1 &&
				this.selectedGeofenceProducts[0] === PRODUCT_NAMES.GEOVIDEO
			) {
				this.geoVideoMarkers && this.geoVideoMarkers.length > 0
					? this.drawGeoProductsMapBounds(mapBounds, zoomRange)
					: this.setDefaultMap();
			} else if (this.selectedGeofenceProducts[0] === PRODUCT_NAMES.GEOFENCE) {
				this.geoFenceMarkers && this.geoFenceMarkers.length > 0
					? this.drawGeoProductsMapBounds(mapBounds, zoomRange)
					: this.setDefaultMap();
			}
		} else {
			this.setDefaultMap();
		}
	}

	setDefaultMap() {
		this.map.easeTo({
			padding: { top: 100, bottom: 300, left: 400, right: 20 },
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom, // starting zoom
			duration: 0
		});
	}

	drawGeoProductsMapBounds(mapBounds, zoomRange) {
		if (!_.isEmpty(mapBounds)) {
			this.map.fitBounds(mapBounds, {
				padding: { top: 100, bottom: 300, left: 400, right: 20 },
				linear: true,
				maxZoom: zoomRange
			});
		}
	}

	drawGeoFenceLayers() {
		if (this.displayGeoFenceData) {
			if (!this.geoFenceMarkersDrawn) {
				this.removeGeoFenceMarker();
				this.geoFenceMarkersDrawn = true;
				this.geoFenceMarkers = [];
				this.drawGeoFenceMarkers(this.displayGeoFenceData, '_geofence', PRODUCT_NAMES.GEOFENCE);
			}
		}
		if (this.prerollGeoFenceData && this.prerollGeoFenceData.length > 0) {
			if (!this.geoVideoMarkersDrawn) {
				this.removeGeoVideoMarker();
				this.geoVideoMarkersDrawn = true;
				this.geoVideoMarkers = [];
				this.drawGeoFenceMarkers(this.prerollGeoFenceData, '_geovideo', PRODUCT_NAMES.GEOVIDEO);
			}
		}
	}

	drawAllGeoFencePoints() {
		if (this.displayGeoFenceData) {
			this.drawGeoFencePoints(this.displayGeoFenceData, '_geofence');
		}
		if (this.prerollGeoFenceData) {
			this.drawGeoFencePoints(this.prerollGeoFenceData, '_geovideo');
		}
	}

	drawGeoRecencyLayers() {
		if (this.displayGeoRecencyData) {
			this.geoFenceRecencyLayersDrawn = true;
			this.drawGeoRecencyLayer(this.displayGeoRecencyData, '_display_georecency');
		}
		if (this.prerollGeoRecencyData) {
			this.geoVideoRecencyLayersDrawn = true;
			this.drawGeoRecencyLayer(this.prerollGeoRecencyData, '_preroll_georecency');
		}
	}

	drawGeoRecencyLayer(geoFenceData?, layerId?) {
		this.removeMapLayer('geofence_points' + layerId);
		this.removeMapSource('geofence_points' + layerId);
		setTimeout(
			function () {
				if (this.map && !this.map.getLayer('geofence_points' + layerId)) {
					if (geoFenceData && geoFenceData.features && geoFenceData.features.length > 0) {
						this.map.addLayer({
							id: 'geofence_points' + layerId,
							type: 'circle',
							source: {
								type: 'geojson',
								data: geoFenceData
							},
							paint: {
								'circle-color': this.geoRecencyCircleColor,
								'circle-stroke-width': 1,
								'circle-stroke-color': this.geoRecencyCircleStrokeColor
							}
						});
					}
				}
			}.bind(this)
		);
	}

	drawGeoFenceMarkers(geoFenceData, layerId, productName) {
		geoFenceData.features.forEach((marker) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.width = 30 + 'px';
			el.style.height = 30 + 'px';
			el.addEventListener('click', (event) => {
				const centerPoint: any = [marker.properties.center_point_longitude, marker.properties.center_point_latitude];
				this.map.flyTo({
					center: centerPoint,
					zoom: 13,
					speed: 4
				});
			});
			// add marker to map
			const gfMarker: any = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);

			el.addEventListener('mouseover', (event) => {
				const address = marker.properties.name;
				const content = '<div><strong>' + address + '</strong></div>';
				jQuery('#info').html(content);
				const height = jQuery('#info').height();
				const width = jQuery('#info').width();
				const x = gfMarker._pos.x;
				const y = gfMarker._pos.y;
				const top = y - (height + 44);
				const left = x - (width / 2 + 20);

				jQuery('#info').css('top', top);
				jQuery('#info').css('left', left);
				jQuery('#info').css('opacity', 1);
				if (marker.properties.is_simplifi_restricted_geopoint) {
					jQuery('.geofence-disclaimer').css('display', 'block');
				}
			});

			el.addEventListener('mouseout', (event) => {
				jQuery('#info').css('opacity', 0);
				if (marker.properties.is_simplifi_restricted_geopoint) {
					jQuery('.geofence-disclaimer').css('display', 'none');
				}
			});

			if (PRODUCT_NAMES.GEOFENCE === productName) {
				this.geoFenceMarkers.push(gfMarker);
			} else if (PRODUCT_NAMES.GEOVIDEO === productName) {
				this.geoVideoMarkers.push(gfMarker);
			}
		});
	}

	drawGeoFencePoints(geoFenceData?, layerId?) {
		if (geoFenceData && geoFenceData.features && geoFenceData.features.length > 0) {
			this.map.addLayer({
				id: 'geofence_points' + layerId,
				type: 'circle',
				source: {
					type: 'geojson',
					data: geoFenceData
				},
				paint: {
					'circle-color': this.geoFenceCircleColor,
					'circle-stroke-width': 1,
					'circle-stroke-color': this.geoFenceStrokeColor
				}
			});
		}
	}

	/**
	 * manage polygon center layer and polygon layer based on zoom level
	 */
	zoomChanged() {
		if (this.map.getZoom() > 6) {
			if (this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'visible');
			}
			if (this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'none');
			}
		} else {
			if (this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'visible');
			}
			if (this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'none');
			}
		}
	}

	/**
	 * Remove geofence layer if geofence is not selected
	 */
	removeGeofenceLayer() {
		if (this.geofenceLegend && (!this.geofenceLegend.selected || !this.geofenceLegend.show)) {
			if (this.map && this.map.getLayoutProperty('geofence-markers', 'visibility')) {
				this.map.setLayoutProperty('geofence-markers', 'visibility', 'none');
			}
		} else {
			if (this.map && this.map.getLayoutProperty('geofence-markers', 'visibility')) {
				this.map.setLayoutProperty('geofence-markers', 'visibility', 'visible');
			}
		}
	}

	/**
	 * toggle geofence and manage geofence layer
	 * @param flag - toggle value of geofence
	 */
	toggleGeofenceData(flag) {
		this.geofenceLegend.selected = !flag;
		this.removeGeofenceLayer();
	}

	processProductToggleResponse(response) {
		const selectedProducts = response.selected;
		const removedProducts = response.removed;
		this.showLiftDetails = response.showLiftDetails;
		this.updateLegendItems(selectedProducts);
		this.checkIfOnlyGeoFenceProductsSelected(selectedProducts);
		this.checkForGeoFenceProducts(selectedProducts, removedProducts);
		if (this.mapObj) {
			const key = this.generateCombinationKeyBySelectedProducts(selectedProducts);
			const combinationObj: any = _.findWhere(this.mapObj.combinations, { key: key });
			this.selectedCombination = combinationObj;
		}
		// this.refreshMap();
		// this.drawCenter(); commenting this as it is not required to draw center on product toggle
		this.processResponseData(); // adding this to process the response data after product toggle
	}

	generateCombinationKeyBySelectedProducts(selectedProducts) {
		const legend: MapLegendItem[] = this.mapObj.legend;
		const selectedLegendItems = [];
		for (const selectedProduct of selectedProducts) {
			const legendObj = _.findWhere(legend, { productKey: selectedProduct.productKey });
			if (legendObj && !legendObj.isDependent) {
				selectedLegendItems.push(legendObj);
			}
		}
		const productKeys = _.pluck(selectedLegendItems, 'productKey');
		const combinationKey = this.getCombinationKeyByProductKeys(productKeys);
		return combinationKey;
	}

	updateLegendItems(selectedProducts) {
		const productKeys = _.pluck(selectedProducts, 'productKey');
		this.legendItems.map((legendItem: MapLegendItem) => {
			legendItem.isSelected = _.indexOf(productKeys, legendItem.productKey) !== -1;
		});
	}

	checkIfOnlyGeoFenceProductsSelected(selectedProducts) {
		const productNames = _.pluck(selectedProducts, 'productName');
		const geofenceProductNames = _.pluck(this.GF_PRODUCTS, 'productName');
		const defaultProductNames = _.pluck(this.DEFAULT_PRODUCTS, 'productName');
		const selectedGeoFenceProducts = _.intersection(productNames, geofenceProductNames);
		const selectedDefaultProducts = _.intersection(productNames, defaultProductNames);
		this.selectedGeofenceProducts = selectedGeoFenceProducts;
		if (selectedDefaultProducts.length === 0 && selectedGeoFenceProducts.length > 0) {
			this.onlyGeoFenceProductsSelected = true;
		} else {
			this.onlyGeoFenceProductsSelected = false;
		}

		if (selectedGeoFenceProducts.length > 0) {
			this.showGeofenceLegends = true;
		} else {
			this.showGeofenceLegends = false;
		}
	}

	checkForGeoFenceProducts(selectedProducts, removedProducts) {
		if (selectedProducts.length > 0) {
			const productNames = _.pluck(selectedProducts, 'productName');
			const geofenceProductNames = _.pluck(this.GF_PRODUCTS, 'productName');

			const selectedGeoFenceProducts = _.intersection(productNames, geofenceProductNames);
			if (selectedGeoFenceProducts.length > 0) {
				if (selectedGeoFenceProducts.length === this.GF_PRODUCTS.length) {
					this.drawGeoFenceLayers();
					this.drawGeoRecencyLayers();
				} else if (selectedGeoFenceProducts.length === 1) {
					if (selectedGeoFenceProducts[0] === PRODUCT_NAMES.GEOFENCE) {
						this.drawGeoFenceMarkersOnMap();
						this.drawGeoFenceRecencyLayer();
					} else if (selectedGeoFenceProducts[0] === PRODUCT_NAMES.GEOVIDEO) {
						this.drawGeoVideoMarkers();
						this.drawGeoVideoRecencyLayer();
					}
				}
				this.drawMap();
			}
		}

		if (removedProducts.length > 0) {
			const productNames = _.pluck(removedProducts, 'productName');
			const selectedProductNames = _.pluck(selectedProducts, 'productName');
			const geofenceProductNames = _.pluck(this.GF_PRODUCTS, 'productName');

			const removedGeoFenceProducts = _.intersection(productNames, geofenceProductNames);
			const selectedGeoFenceProducts = _.intersection(selectedProductNames, geofenceProductNames);

			if (removedGeoFenceProducts.length > 0) {
				if (removedGeoFenceProducts.length === this.GF_PRODUCTS.length) {
					this.removeAllGeoFenceMarkers();
					this.removeAllGeoRecencyLayers();
				} else if (removedGeoFenceProducts.length === 1) {
					if (removedGeoFenceProducts[0] === PRODUCT_NAMES.GEOFENCE && !selectedGeoFenceProducts.length) {
						this.removeGeoFenceMarker();
						this.removeGeoFenceRecencyLayer();
					} else if (removedGeoFenceProducts[0] === PRODUCT_NAMES.GEOVIDEO && !this.selectedGeofenceProducts.length) {
						this.removeGeoFenceMarker();
						this.removeGeoFenceRecencyLayer();
						this.removeGeoVideoMarker();
						this.removeGeoVideoRecencyLayer();
					} else if (removedGeoFenceProducts[0] === PRODUCT_NAMES.GEOVIDEO) {
						this.removeGeoVideoMarker();
						this.removeGeoVideoRecencyLayer();
					}
				}
			}
		}
	}

	removeAllGeoFenceMarkers() {
		if (this.geoFenceMarkersDrawn) {
			this.removeGeoFenceMarker();
		}

		if (this.geoVideoMarkersDrawn) {
			this.removeGeoVideoMarker();
		}
	}

	removeGeoFenceMarker() {
		this.geoFenceMarkersDrawn = false;
		for (const marker of this.geoFenceMarkers) {
			marker.remove();
		}
	}

	removeGeoVideoMarker() {
		this.geoVideoMarkersDrawn = false;
		for (const marker of this.geoVideoMarkers) {
			marker.remove();
		}
	}

	drawGeoFenceMarkersOnMap() {
		if (this.displayGeoFenceData && !this.geoFenceMarkersDrawn) {
			this.geoFenceMarkersDrawn = true;
			this.drawGeoFenceMarkers(this.displayGeoFenceData, '_geofence', PRODUCT_NAMES.GEOFENCE);
		}
	}

	drawGeoVideoMarkers() {
		if (this.prerollGeoFenceData && this.prerollGeoFenceData.features.length > 0 && !this.geoVideoMarkersDrawn) {
			this.geoVideoMarkersDrawn = true;
			this.drawGeoFenceMarkers(this.prerollGeoFenceData, '_geovideo', PRODUCT_NAMES.GEOVIDEO);
		}
	}

	drawGeoFenceRecencyLayer() {
		if (this.displayGeoRecencyData && !this.geoFenceRecencyLayersDrawn) {
			this.drawGeoRecencyLayer(this.displayGeoRecencyData, '_display_georecency');
		}
	}

	removeGeoFenceRecencyLayer() {
		if (this.displayGeoRecencyData && this.geoFenceRecencyLayersDrawn) {
			this.removeMapLayer('geofence_points_display_georecency');
		}
	}

	drawGeoVideoRecencyLayer() {
		if (this.prerollGeoRecencyData && !this.geoVideoRecencyLayersDrawn) {
			this.drawGeoRecencyLayer(this.prerollGeoRecencyData, '_preroll_georecency');
		}
	}

	removeGeoVideoRecencyLayer() {
		if (this.map && this.prerollGeoRecencyData && this.geoVideoRecencyLayersDrawn) {
			this.removeMapLayer('geofence_points_preroll_georecency');
		}
	}

	removeAllGeoRecencyLayers() {
		if (this.map) {
			this.removeGeoVideoRecencyLayer();
			this.removeGeoFenceRecencyLayer();
		}
	}
}
